/* Object */

function exists(obj) {
  return typeof obj !== 'undefined';
}

function isString(obj) {
  return typeof obj === 'string' || obj instanceof String;
}

function isDate(obj) {
  return obj instanceof Date;
}

function isArray(obj) {
  return obj && Array.isArray(obj);
}

/* String */

function isEmpty(str) {
  return !str || str.length === 0;
}

function contains(str, value) {
  return !str || str.indexOf(value) !== -1;
}

function toUpper(str) {
  return isEmpty(str) ? '' : str.toUpperCase();
}

function toLower(str) {
  return isEmpty(str) ? '' : str.toLowerCase();
}

function toBoolean(str) {
  const result = str === 'true' ? true : str === 'false' ? false : null;
  return result;
}

function join(arr, seperator) {
  if (arr && arr.length > 0) {
    const array = [];
    for (let i = 0; i < arr.length; i++) {
      if (isString(arr[i]) && !isEmpty(arr[i])) {
        array.push(arr[i]);
      }
    }
    return array.join(seperator || ' ');
  }
  return '';
}

/* Date */

function toApiDateTimeObject(obj) {
  // adds one to the month value in order for the API to interpret correctly
  if (obj) {
    const date = new Date(obj);
    if (date == null || isNaN(date.getTime())) {
      return null;
    }
    return {
      year: date.getFullYear(),
      month: date.getMonth() + 1,
      day: date.getDate(),
      hours: date.getHours(),
      minutes: date.getMinutes(),
      seconds: date.getSeconds()
    };
  }
  else {
    return null;
  }
}

/* Url */

function getUrlParameter(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
  var results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

/* Array */

function insertIntoSortedArray(array, sortColumn, item) {
  let clone = [...array];
  let index = 0;
  for (let i = 0; i < clone.length; i++) {
    if (clone[i][sortColumn].toUpperCase() >= item[sortColumn].toUpperCase()) {
      index = i;
      break;
    }
  }
  clone.splice(index, 0, item);
  return clone;
};




const Helpers = {
  Object: {
    exists,
    isString,
    isDate,
    isArray,
  },
  String: {
    isEmpty,
    contains,
    toUpper,
    toLower,
    toBoolean,
    join,
  },
  Date: {
    toApiDateTimeObject,
  },
  Url: {
    getUrlParameter,
  },
  Array: {
    insertIntoSortedArray,
  },
};

export default Helpers;